<template>
    <div class="cambio">
        <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
            <span class="badge" :class="claseOperacion(cambio.operacion)">{{ textoOperacion(cambio.operacion) }}</span>
            <code class="text-sm">{{ cambio.tabla }}</code>
            <span v-if="cambio.registro_id" class="text-xs text-muted">#{{ cambio.registro_id }}</span>
            <a
                v-if="conHistorial && cambio.registro_id"
                href="#"
                class="text-xs ms-auto"
                @click.prevent="$emit('historial', { tabla: cambio.tabla, registro_id: cambio.registro_id })"
            >
                <i class="fas fa-history me-1"></i>
                Historial del registro
            </a>
        </div>

        <div v-if="cambio.nota" class="nota text-xs mb-2">
            <i class="fas fa-info-circle me-1"></i>
            {{ cambio.nota }}
        </div>

        <!-- Editar: solo los campos que cambiaron -->
        <div v-if="filasEditar.length" class="table-responsive">
            <table class="table table-sm tabla-cambios mb-0">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Antes</th>
                        <th>Después</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="fila in filasEditar" :key="fila.campo">
                        <td class="fw-semibold">{{ fila.campo }}</td>
                        <td class="valor valor-antes">
                            <span v-if="fila.antes == null" class="valor-nulo">null</span>
                            <template v-else>{{ fila.antes }}</template>
                        </td>
                        <td class="valor valor-despues">
                            <span v-if="fila.despues == null" class="valor-nulo">null</span>
                            <template v-else>{{ fila.despues }}</template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Crear / borrar (fila completa), o editar sin detalle con solo los valores nuevos -->
        <div v-else-if="filaCompleta.length" class="table-responsive fila-completa">
            <table class="table table-sm tabla-cambios mb-0">
                <tbody>
                    <tr v-for="[campo, valor] in filaCompleta" :key="campo">
                        <td class="fw-semibold">{{ campo }}</td>
                        <td class="valor" :class="cambio.operacion === 'borrar' ? 'valor-antes' : 'valor-despues'">
                            <span v-if="valor == null" class="valor-nulo">null</span>
                            <template v-else>{{ valor }}</template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
const OPERACIONES = {
    crear: { texto: 'Creado', clase: 'bg-success' },
    editar: { texto: 'Editado', clase: 'bg-info' },
    borrar: { texto: 'Borrado', clase: 'bg-danger' },
};

export default {
    name: 'CambioAuditoria',
    props: {
        cambio: { type: Object, required: true },
        conHistorial: { type: Boolean, default: true }
    },
    emits: ['historial'],
    computed: {
        filasEditar() {
            return this.cambio.operacion === 'editar' && Array.isArray(this.cambio.campos) ? this.cambio.campos : [];
        },
        filaCompleta() {
            const fila = this.cambio.operacion === 'borrar' ? this.cambio.antes : this.cambio.despues;
            return fila && typeof fila === 'object' ? Object.entries(fila) : [];
        }
    },
    methods: {
        textoOperacion: (op) => OPERACIONES[op]?.texto || op,
        claseOperacion: (op) => OPERACIONES[op]?.clase || 'bg-secondary'
    }
};
</script>

<style lang="scss" scoped>
.cambio {
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.75rem;
    background: #fff;

    & + & {
        margin-top: 0.75rem;
    }
}

.nota {
    background: #fff7e6;
    color: #8a6d1d;
    border-radius: 0.375rem;
    padding: 0.4rem 0.6rem;
}

.tabla-cambios {
    font-size: 0.75rem;

    th {
        font-size: 0.7rem;
        color: #8392ab;
        font-weight: 700;
        text-transform: uppercase;
    }

    td {
        vertical-align: top;
        color: #344767;
    }

    td:first-child {
        width: 30%;
        word-break: break-word;
    }
}

.valor {
    font-family: SFMono-Regular, Menlo, Consolas, monospace;
    white-space: pre-wrap;
    word-break: break-word;
}

.valor-antes {
    background: #fef2f2;
}

.valor-despues {
    background: #ecfdf3;
}

.valor-nulo {
    color: #94a3b8;
    font-style: italic;
}

.fila-completa {
    max-height: 260px;
    overflow-y: auto;
}
</style>
